module.exports = __webpack_public_path__ + "img/04.a5755e07.gif";